// extracted by mini-css-extract-plugin
export default {"link":"src-components-Link-GreenLink-css-module__link--hBmgJ","disabled":"src-components-Link-GreenLink-css-module__disabled--c86uM"};